import { searchDumpStations } from '../../util/api';
import { storableError } from '../../util/errors';
import { parse } from '../../util/urlHelpers';

// Action types
const SEARCH_REQUEST = 'app/DumpStationSearchPage/SEARCH_REQUEST';
const SEARCH_SUCCESS = 'app/DumpStationSearchPage/SEARCH_SUCCESS';
const SEARCH_ERROR = 'app/DumpStationSearchPage/SEARCH_ERROR';
const SET_ACTIVE_STATION = 'app/DumpStationSearchPage/SET_ACTIVE_STATION';

/** @type {import('../../../types/vansite').VanSite.State.DumpStationSearchPage} */
const initialState = {
  stations: [],
  searchInProgress: false,
  searchError: null,
  activeStationId: null,
  meta: null,
};

const reducer = (state = initialState, action = {}) => {
  const { type, payload } = action;
  switch (type) {
    case SEARCH_REQUEST:
      return { ...state, searchInProgress: true, searchError: null };
    case SEARCH_SUCCESS:
      return {
        ...state,
        stations: payload.data,
        meta: payload.meta,
        searchInProgress: false,
      };
    case SEARCH_ERROR:
      return { ...state, searchInProgress: false, searchError: payload };
    case SET_ACTIVE_STATION:
      return { ...state, activeStationId: payload };
    default:
      return state;
  }
};

export default reducer;

// Action creators
const searchRequest = () => ({ type: SEARCH_REQUEST });
const searchSuccess = (payload) => ({ type: SEARCH_SUCCESS, payload });
const searchError = (e) => ({ type: SEARCH_ERROR, payload: e, error: true });

export const setActiveStation = (id) => ({ type: SET_ACTIVE_STATION, payload: id });

// Thunks
export const searchStations = (params) => async (dispatch) => {
  dispatch(searchRequest());
  try {
    const response = await searchDumpStations(params);
    dispatch(searchSuccess(response));
  } catch (e) {
    dispatch(searchError(storableError(e)));
  }
};

export const loadData = (params, search) => (dispatch) => {
  const queryParams = parse(search, { latlngBounds: ['bounds'] });
  const { bounds, greyWater, chemicalToilet, fee, waterRefill, powerSupply, basin, page } = queryParams;

  if (!bounds) return Promise.resolve();

  const apiParams = {
    bounds: `${bounds.ne.lat},${bounds.ne.lng},${bounds.sw.lat},${bounds.sw.lng}`,
  };

  if (greyWater) apiParams.greyWater = 'true';
  if (chemicalToilet) apiParams.chemicalToilet = 'true';
  if (fee) apiParams.fee = 'true';
  if (waterRefill) apiParams.waterRefill = 'true';
  if (powerSupply) apiParams.powerSupply = 'true';
  if (basin) apiParams.basin = 'true';
  if (page) apiParams.page = String(page);

  return dispatch(searchStations(apiParams));
};
